import { useEffect, useState } from 'react';
import './styles.css';
import api from '../../services/api';
import { useLocation } from 'react-router-dom';
import useDriver from '../../hooks/useDriver';

export function CookieBanner() {
    const [revertButton, setRevertButton] = useState(false);
    const [nivelAcesso, setNivelAcesso] = useState();
    const location = useLocation();
    const { startDriverTutorial } = useDriver(location.pathname); // Desestruture startDriverTutorial

    useEffect(() => {
        const fetchData = async () => {
            const response = await api.get('verifica-tutorial-driver');
            console.log("🚀 ~ fetchData ~ response:", response.data);
            setRevertButton(response.data);
            const nivelAcesso = await api.get('nivel-acesso');
            console.log("🚀 ~ fetchData ~ nivelAcesso:", nivelAcesso)
            setNivelAcesso(nivelAcesso.data.nivel);
        }
        fetchData();
    }, []);

    const activateCookie = async () => {
        try {
            if (revertButton == false) {
                await api.put(`habilitar-driver-por-usuario/${true}`);
                setRevertButton(true);
            } else {
                await api.put(`habilitar-driver-por-usuario/${false}`);
                setRevertButton(false);
            } 
        } catch (error) {
            console.error(error);
        }
    };

    const handleShowTutorial = () => {
        startDriverTutorial(); 
    };

    return (
        (nivelAcesso !== 4 && location.pathname === "/pgr") ? (
            <div className="banner">
                <div className="text-area">
                    <p className="text">
                        Olá! O tutorial será exibido toda vez que você acessar o Meu PGR. Aqui você pode definir se deseja manter a exibição do tutorial para suas próximas visitas. Caso queira visualizar o tutorial neste momento, clique em 'Mostrar Tutorial'
                    </p>
                </div>
                <div className="button-container">
                    <button className="button" onClick={activateCookie}>
                        {revertButton == false ? 'Ativar Tutorial' : 'Desativar Tutorial'}
                    </button>
                    <button className="button" onClick={handleShowTutorial}>
                        Mostrar Tutorial
                    </button>
                </div>
            </div>
        ) : (<></>)
    );
}

export default CookieBanner;
